import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BehaviorSubject } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';

import { UiIconsList } from '../../model/ui-icons.model';
import { UiIconsService } from '../../services/ui-icons.service';

@Component({
  selector: 'ui-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IconComponent implements AfterViewInit {
  #smartheadIconsService = inject(UiIconsService);
  #renderer = inject(Renderer2);
  #destroyRef = inject(DestroyRef);
  #container = inject(ElementRef<any>);

  #iconKeyChanges$ = new BehaviorSubject<UiIconsList>(this.key);
  @Input({ required: true }) set key(keyValue: UiIconsList) {
    this.#iconKeyChanges$.next(keyValue);
  }

  ngAfterViewInit(): void {
    this.#iconKeyChanges$
      .pipe(
        switchMap(key => this.#smartheadIconsService.getIconContent(key).pipe(first())),
        tap(iconContent => this.#renderer.setProperty(this.#container.nativeElement, 'innerHTML', iconContent)),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe();
  }
}
